// extracted by mini-css-extract-plugin
export default {"container":"BannerLottie_container__nkbLq","containerMobile":"BannerLottie_containerMobile__kB+UD"};